import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {
    Avatar,
    Button,
    Card,
    CardContent,
    CardMedia,
    Container,
    Divider,
    Grid,
    IconButton,
    Link,
    Menu,
    MenuItem,
    Modal,
    Stack,
    Typography
} from "@mui/material";
import androidBadge from "../../media/google-play-badge.png";
import iosBadge from "../../media/ios.svg";
import CircularProgress from "@mui/material/CircularProgress";
import CustomButton from "../../Components/CustomButton";
import Iconify from "../../Components/Iconify";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { collection, doc, getDoc, getDocs, query } from "firebase/firestore";
import { db, functions } from "../../firebase.config";
import { httpsCallable } from "firebase/functions";
import PdfTickets from "../../Components/pdf/pdfTickets";
import { PDFDownloadLink } from "@react-pdf/renderer";
import TrackPurchase from "../../Components/trackPurchase";
var QRCode = require("qrcode");

// ----------------------------------------------------------------------

const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minWidth: { xs: "100%", sm: 400 },
    bgcolor: "white",
    border: "1px solid white",
    borderRadius: "7px",
    boxShadow: 0,
    p: 3,
};

export default function WaitingPaiement() {
    const { eventID, billId } = useParams();
    const [loading, setLoading] = React.useState();
    const [event, setEvent] = React.useState([]);
    const [org, setOrg] = React.useState();
    const [bill, setBill] = React.useState([]);
    const [order, setOrder] = React.useState();
    const [qrcodes, setQrcodes] = React.useState([]);
    const [config, setConfig] = React.useState([]);
    const [data, setData] = React.useState();
    const [refCommande, setRefCommande] = React.useState();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    React.useEffect(() => {
        let intervalId;
        let attempts = 0; // Compteur pour 31 minutes

        const checkPaymentStatus = async () => {
            try {
                console.log("Vérification du paiement...");
                
                const docRef = doc(db, "bills", `${billId}`);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    const confirmationData = docSnap.data();

                    if (confirmationData.status === 1) {
                        console.log("Paiement confirmé !");
                        clearInterval(intervalId);
                        navigate(`/fr/checkout_embed/${confirmationData.confirmID}/confirmation`);
                    }
                }
            } catch (error) {
                console.error("Erreur de vérification :", error);
            }

            attempts++;

            if (attempts >= 31) {
                clearInterval(intervalId);
                // setError("Le paiement n'a pas été confirmé. Veuillez réessayer ou contacter le support.");
            }
        };

        intervalId = setInterval(checkPaymentStatus, 60000); // toutes les 60 secondes

        // Nettoyage si l'utilisateur quitte la page
        return () => clearInterval(intervalId);
    }, [billId]);


    return (
        <Container sx={{ paddingY: 15 }}>


            <Box
                sx={{ paddingY: 20 }}
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Stack justifyContent="center" alignItems="center">
                    <Typography variant="h4">
                        Ne pas fermer cette page
                    </Typography>
                    <Typography variant="body1" fontSize={17}>
                        Paiment en attente
                    </Typography>

                    <CircularProgress sx={{ color: "#5E17EB", width: 70, height: 70 }} />
                </Stack>
            </Box>

        </Container>
    );
}
